/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConstructionDayReport } from '../../models/construction-day-report';

export interface ApiV0ConstructiondayreportCreateReportsPost$Json$Params {
      body?: Array<ConstructionDayReport>
}

export function apiV0ConstructiondayreportCreateReportsPost$Json(http: HttpClient, rootUrl: string, params?: ApiV0ConstructiondayreportCreateReportsPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructiondayreportCreateReportsPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

apiV0ConstructiondayreportCreateReportsPost$Json.PATH = '/api/v0/constructiondayreport/createReports';
